import { render, staticRenderFns } from "./color-widget.vue?vue&type=template&id=4a9f81c8&scoped=true"
import script from "./color-widget.vue?vue&type=script&lang=js"
export * from "./color-widget.vue?vue&type=script&lang=js"
import style0 from "./color-widget.vue?vue&type=style&index=0&id=4a9f81c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f81c8",
  null
  
)

export default component.exports